var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    stroke: "#2C67F1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1275 24.7008C10.4043 24.8574 10.5426 24.9357 10.7379 24.9764C10.8894 25.0079 11.1106 25.0079 11.2621 24.9764C11.4574 24.9357 11.5957 24.8574 11.8725 24.7008C14.3076 23.3228 21 18.9942 21 13.0427V7.24395C21 6.27453 21 5.78983 20.8366 5.37317C20.6922 5.0051 20.4575 4.67667 20.1529 4.41629C19.8081 4.12154 19.3403 3.95135 18.4045 3.61096L11.7022 1.17299C11.4424 1.07846 11.3124 1.0312 11.1788 1.01246C11.0602 0.995845 10.9398 0.995845 10.8212 1.01246C10.6876 1.0312 10.5576 1.07846 10.2978 1.17299L3.5955 3.61096C2.65975 3.95135 2.19187 4.12154 1.84707 4.41629C1.54248 4.67667 1.30785 5.0051 1.16345 5.37317C1 5.78983 1 6.27453 1 7.24395V13.0427C1 18.9942 7.69245 23.3228 10.1275 24.7008Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8872 15.5989V8.44571",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6311 11.9672H7.25684",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.7835c028ed695e0c92068120df74dd2c.svg";
export { ForwardRef as ReactComponent };